/**
 * Build a `tel:` href from a display phone string (PD-14363). The admin
 * types the number as it should READ (e.g. "1-800-555-0100"); the href
 * needs only the dialable characters, so strip everything except digits
 * and a leading `+`.
 */
export function telHref(displayPhone: string): string {
	return `tel:${displayPhone.replace(/[^+\d]/g, '')}`;
}
